// src/reducer/UserListReducer.js
import * as types from "../action/ActionType";
import { CUSTOMER_FILTER_INITIAL } from "../store/InitialStore";

export default function UserListReducer(state = CUSTOMER_FILTER_INITIAL, action) {
  const { type, payload } = action;
  
  switch (type) {
    case types.CUSTOMER_SELECT_LIST_FILTER:
      return payload; // Replace the state with the new array of users
    default:
      return state;
  }
}
